/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function() {
    var s = $("#Header");
    var pos = s.position();   				    
    $(window).scroll(function() {
   	 var windowpos = $(window).scrollTop();
   	 if (windowpos >= 50) {
   		 s.addClass("scroll");
   	 } else {
   		 s.removeClass("scroll");    
   	 }
    });
});




 $('#select_option select').change(function() {
    var value = this.value;
    var index = $(this).find(':selected').data('option-position');
   console.log('value = '+value+' ---index = '+index);
    $('#message_field').css('display','block');
   if(index == '1'){
     $('#message_field label').text("Please specify your product request");
   }else if(index == 2){
     $('#message_field label').text("Please advise us of your availabilities");
   }else{
     $('#message_field label').text("Please specify your request");
   }
    
  });

$(document).mouseup(function (e) {
    var $slideout = $('#product-couture-form .wrapper-couture-form');
    if (!$slideout.is(e.target) && $slideout.has(e.target).length === 0)
    {
      $('#product-couture-form').removeClass('open');
    }
  });

